import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../../app/tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';


@Component({
  selector: 'app-login-integrado',
  templateUrl: './login-integrado.component.html',
  styleUrls: ['./login-integrado.component.css']
})
export class LoginIntegradoComponent implements OnInit {
  hideLoginLoad: boolean = false;
  urlDestino: any = '';
  tmsTOKEN: any = '';
  tmsSO: any = '';
  constructor(private route: ActivatedRoute, public router: Router, private _location: Location, public tmaService: TamasAlunoService,  public dialog: MatDialog) { }

  ngOnInit() {
    this.consultarDados();
  }

  consultarDados() : void{
    //verificar se dados existem
    if(this.route.snapshot.paramMap.get('email') != null){
      //ok existe 
      this.urlDestino = this.route.snapshot.paramMap.get('destino');
      this.tmsTOKEN = this.route.snapshot.paramMap.get('token');
      this.tmsSO = this.route.snapshot.paramMap.get('so');
      this.tmaService.hcSO =   this.tmsSO;
      this.checkCredenciais(this.route.snapshot.paramMap.get('email'), this.route.snapshot.paramMap.get('senha'));
    }
    else{
      //redirecionar para login tradicional
      this.router.navigate(['/login']);
    }



  }


  checkCredenciais(useremail: any, userpw: any) :void{
    this.hideLoginLoad = false;
    //var meusDados = 'email=' + useremail + '&senha=' + userpw;
    var qUserAgent = "";
    var meuToken = "";
    console.log(window.navigator.userAgent);
    console.log(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent));
    if(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent)){
      qUserAgent = "Safari";
    }
    else{
      qUserAgent = "Web";
    }
    //acredito que nunca vai ser null o  tmsToken - verificar depois
    var qToken = [];
    if (localStorage.getItem('tmsToken') != null) {
      qToken = JSON.parse(localStorage.getItem('tmsToken'));
      meuToken = qToken['token'];
    }
    // else{
    //   if(localStorage.getItem('tmsMerge') != null){
    //     var dadosMerge = [];
    //     dadosMerge = JSON.parse(localStorage.getItem('tmsMerge'));
    //     meuToken = dadosMerge['token'];
    //     qUserAgent = dadosMerge['so'];
    //   }
    // }

    // if(meuToken == ''){
      
    // }

    if(localStorage.getItem('tmsMerge') != null){
      var dadosMerge = [];
      dadosMerge = JSON.parse(localStorage.getItem('tmsMerge'));
      meuToken = dadosMerge['token'];
      qUserAgent = dadosMerge['so'];
    }
    else{
      meuToken = this.tmsTOKEN;
      qUserAgent = this.tmsSO
    }

    meuToken = this.tmsTOKEN;
      qUserAgent = this.tmsSO

    let customParams = {
      email: useremail,
      senha: userpw,
      token: meuToken,
      so: qUserAgent
     };

    this.tmaService.getLogin(customParams)
    .subscribe((qDados) =>{
      this.hideLoginLoad = true;
        console.log(qDados);
        if(qDados.length == 0){
            // console.log("Algo errado");
            // this.hideLoginLoad = true;
            // const erroInternet = this.dialog.open(AlertaSimplesDialog, {
            //     width: '250px',
            //     data: {textoAlerta: "<b>Por favor verifique sua conexão com a internet</b>"}
            // });
            // return;
           
        }
        if (qDados['res'] == 'done'){
          this.hideLoginLoad = true;
            this.tmaService.logado = true;
            //this.tmaService.logadoNome = qDados['nome'];
            this.tmaService.hcEmail = useremail
            this.tmaService.hcSenha = userpw;
            this.tmaService.hcNomeUsuario = qDados['nomeusuario'];
            this.tmaService.hcNome = qDados['nomefull'];
            this.tmaService.hcIsPro = qDados['isPro'];
            this.tmaService.hcTreinoFix = qDados['treinoFix'];
            this.tmaService.hcDietaFix = qDados['dietaFix'];
            this.tmaService.hcProAtivo = qDados['statusPro'];
            this.tmaService.hcPremium = qDados['statusPremium'];
            this.tmaService.hcFoto = qDados['foto'];
            this.tmaService.hcUid = qDados['uid'];
            //this.tmaService.hcNotify = qDados['numNotify'];
            this.tmaService.notifyQtyhange.next(qDados['numNotify']);

            if(qDados['tema'] == 'light'){
              this.tmaService.setDarkTheme(false);
            }
            else{
              this.tmaService.setDarkTheme(true);
            }
            
            localStorage.removeItem("tmsDadosCliente");
            //treinoFix: qDados['treinoFix'], dietaFix: qDados['dietaFix']
            localStorage["tmsDadosCliente"] = JSON.stringify({ email: useremail, senha: userpw  });
            console.log("logado");
            if (qDados['status'] == true) {
              this.tmaService.hcEtapa = 8;
              
              //redirecionamos para a urlDestino
              //fazer um replace nos %2F

              if(this.urlDestino != ''){
                var destinoF = this.urlDestino.replace(/%2F/gi, '/');
                this.router.navigate([destinoF]);
              }
              else{
                this.router.navigate(['/home']);
              }
            }
            else {
                this.router.navigate(['meu-cadastro/s/' + qDados['etapaCad'] + '/'  + qDados['uid'] + '/' + qDados['codigo']]);
            }

            // if(this.tmaService.paginaAnterior !== ''){
            //     this.router.navigate([this.tmaService.paginaAnterior]);
            // }
            // else{
            //     this.router.navigate(['home']);
            // }
        }
        else{
          //invalid
          this.router.navigate(['/login']);
        }
      }, 
      (error) =>{
        this.hideLoginLoad = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose:true,
        data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
        });
      });       
  }

}
